import { queryClient } from "../../../queryClient";

export const JOURNAL_ENTRY_QUERY_KEY = "journalEntry";

export function removeJournalEntryQueries(journalEntryId?: string) {
    queryClient.removeQueries({
        queryKey: journalEntryId
            ? [JOURNAL_ENTRY_QUERY_KEY, journalEntryId]
            : [JOURNAL_ENTRY_QUERY_KEY],
    });
}
